import { useEffect } from 'react';
import { atom, useAtomValue } from 'jotai';
import { store } from '../services/atom.service';
import { getMyOrganizations, OrganizationSummary } from '../services/organization.service';
import { useAuth } from '../services/useAuth';

const myOrganizationsAtom = atom<OrganizationSummary[] | null>(null);

let inflight: Promise<void> | null = null;

export const refreshMyOrganizations = () => {
    if (!inflight) {
        inflight = getMyOrganizations().then(orgs => {
            store.set(myOrganizationsAtom, orgs);
        }, (err) => {
            console.error(err);
            store.set(myOrganizationsAtom, []);
        }).finally(() => {
            inflight = null;
        });
    }
    return inflight;
}

/**
 * Organizations the current user belongs to (by email domain) or administers.
 */
export const useMyOrganizations = () => {
    const { user } = useAuth();
    const organizations = useAtomValue(myOrganizationsAtom);

    useEffect(() => {
        if (user && organizations === null) {
            refreshMyOrganizations();
        }
    }, [user, organizations]);

    return {
        organizations: organizations || [],
        loading: !!user && organizations === null
    };
}
